import {DeviceMetaInformation} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public DeviceMetaInformation: DeviceMetaInformation,
  ) {}
}